var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(-2910 -23041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 24,
    height: 24,
    transform: "translate(2910 23041)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_115profile",
    "data-name": "Group 115profile",
    transform: "translate(2906.751 23037.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M15.661,20.073a5.411,5.411,0,1,1,5.411-5.411A5.418,5.418,0,0,1,15.661,20.073Zm0-9.411a4,4,0,1,0,4,4A4,4,0,0,0,15.661,10.662Z",
    transform: "translate(-0.412 -0.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M7.955,25.367a.706.706,0,0,1-.631-1.021,9.242,9.242,0,0,1,3.37-3.719,9.021,9.021,0,0,1,9.582,0,9.241,9.241,0,0,1,3.37,3.719.706.706,0,0,1-1.263.63,7.83,7.83,0,0,0-2.854-3.152,7.609,7.609,0,0,0-8.086,0,7.831,7.831,0,0,0-2.854,3.152A.706.706,0,0,1,7.955,25.367Z",
    transform: "translate(-0.236 -0.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M24.838,9.426a2.588,2.588,0,1,1,2.588-2.588A2.591,2.591,0,0,1,24.838,9.426Zm0-3.764a1.176,1.176,0,1,0,1.176,1.176A1.178,1.178,0,0,0,24.838,5.662Z",
    transform: "translate(-1.119 -0.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M24.956,5.6A.706.706,0,0,1,24.25,4.9V3.956a.706.706,0,0,1,1.412,0V4.9A.706.706,0,0,1,24.956,5.6Z",
    transform: "translate(-1.237 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M22.9,6.6a.7.7,0,0,1-.5-.207l-.941-.941a.706.706,0,1,1,1-1L23.4,5.4a.706.706,0,0,1-.5,1.2Z",
    transform: "translate(-1.06 -0.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M21.956,9.6a.706.706,0,0,1-.5-1.2l.941-.941a.706.706,0,0,1,1,1l-.941.941A.7.7,0,0,1,21.956,9.6Z",
    transform: "translate(-1.06 -0.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M24.956,11.544a.706.706,0,0,1-.706-.706V8.956a.706.706,0,0,1,1.412,0v1.882A.706.706,0,0,1,24.956,11.544Z",
    transform: "translate(-1.237 -0.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M27.9,9.6a.7.7,0,0,1-.5-.207l-.941-.941a.706.706,0,1,1,1-1L28.4,8.4a.706.706,0,0,1-.5,1.2Z",
    transform: "translate(-1.354 -0.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M26.956,6.6a.706.706,0,0,1-.5-1.2l.941-.941a.706.706,0,0,1,1,1l-.941.941A.7.7,0,0,1,26.956,6.6Z",
    transform: "translate(-1.354 -0.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M15.256,27.25a12,12,0,1,1-.007-24,10.957,10.957,0,0,1,1.115.05.706.706,0,1,1-.136,1.405,9.565,9.565,0,0,0-.975-.044A10.587,10.587,0,1,0,25.837,15.249a9.677,9.677,0,0,0-.077-1.264.706.706,0,1,1,1.4-.178,11.08,11.08,0,0,1,.088,1.445,12,12,0,0,1-11.992,12Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavAccount);
export default __webpack_public_path__ + "static/media/icon-nav-account.d56c18716397bfec461995487f3a908d.svg";
export { ForwardRef as ReactComponent };